import { UtilitiesService } from '../../services/utilities.service';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'money' })
export class MoneyPipe implements PipeTransform {

    constructor(private utilitiesService: UtilitiesService) {}

    public transform(value: any, precision?: number, preffix?: string, suffix?: string): any {
        precision = precision >= 0 ? precision : 2;
        preffix = typeof(preffix) === 'string' ? preffix : 'R$ ';
        suffix = typeof(suffix) === 'string' ? suffix : '';

        if (typeof(value) === 'number') {
            return `${preffix}${this.utilitiesService.formatCurrencyValue(value, precision)}${suffix}`;
        }

        return null;
    }

}
